import apiConfig from "../../config/apiConfig";
import { END_POINT, PAGE_TYPE } from "../constants";
import { setError } from "./errorAction";
import { objToQueryString } from "../../services/helpers/Helper";
import { hideLoading, showLoading } from "./loadingAction";
import { URL } from "../../routers/constants";
import { loadAllData } from "./conversationAction";
const _ = require('lodash');

export const fetchPages = (navigate) =>
   async (dispatch) => {
      const params = {
         clientType: '',
         revision: '',
         languageCode: '',
         countryCode: '',
         timestamp: new Date().getTime()
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.LIST_PAGES_CONNECTED}?${qs}`
      apiConfig.get(endPoint).then((response) => {
         const { data } = response;
         dispatch({
            type: PAGE_TYPE.FETCH,
            payload: data,
         });
         if (data.length === 0 && navigate) {
            navigate(URL.INTRO);
         }
      }).catch(() => {})
   };

export const setPage = (data, callbackSuccess, callbackError) =>
   async (dispatch) => {
      const params = {
         fb_page_id: data.social_id,
         clientType: '',
         revision: '',
         languageCode: '',
         countryCode: '',
         timestamp: new Date().getTime()
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.LAST_PAGE}?${qs}`;
      // dispatch(loadAllData(data.social_id))
      apiConfig.post(endPoint).then((response) => {
         dispatch({
            type: PAGE_TYPE.SELECT,
            payload: data,
         });
         if (callbackSuccess) {
            callbackSuccess();
         }
      }).catch((error) => {
         if (callbackError) {
            callbackError();
         }
         dispatch(setError(error.message))
      })

   }

export const fetchCurentPage = () =>
   async (dispatch, getState) => {
      const params = {
         clientType: '',
         revision: '',
         languageCode: '',
         countryCode: '',
         timestamp: new Date().getTime()
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.CURRENT_PAGE}?${qs}`
      apiConfig.get(endPoint).then((response) => {
         const { data } = response;
         const { pages } = getState();
         if (pages && pages.length > 0 && _.isEmpty(data)) {
            dispatch(setPage(pages[0]));
         } else {
            dispatch({
               type: PAGE_TYPE.SELECT,
               payload: data,
            });
         }
      }).catch(() => {})
   };

export const disconnectPage = () =>
   async (dispatch, getState) => {
      const { page } = getState();
      const params = {
         fb_page_id: page.social_id,
         clientType: '',
         revision: '',
         languageCode: '',
         countryCode: '',
         timestamp: new Date().getTime(),
      }
      const qs = objToQueryString(params);
      const endPoint = `${END_POINT.STOP_CONNECT_PAGE}?${qs}`
      dispatch(showLoading());
      apiConfig.post(endPoint).then((response) => {
         const { data } = response;
         let { pages } = getState();
         pages = pages.filter((f) => {
            return f.social_id != page.social_id
         });
         if (pages.length > 0 && _.isEmpty(data)) {
            dispatch(setPage(pages[0]));
         } else {
            dispatch({
               type: PAGE_TYPE.SELECT,
               payload: [],
            });
         }
         dispatch(fetchPages());
      }).catch((error) => {
         dispatch(setError(error.message))
      }).finally(() => {
         dispatch(hideLoading());
      })
   }